import { useEffect } from 'react';
import { useAuth as useClerkAuth } from '@clerk/clerk-react';
import { setTokenGetter } from '@/api/client';
import { useSyncFydMe } from '@/store/auth';

// Mount once near the root (inside ClerkProvider). Wires Clerk JWT into the API client
// and triggers an initial /me fetch when the user is signed in.
export function useAuthBootstrap() {
  const { getToken, isLoaded } = useClerkAuth();

  useEffect(() => {
    if (!isLoaded) return;
    setTokenGetter(() => getToken());
    return () => setTokenGetter(null);
  }, [getToken, isLoaded]);

  useSyncFydMe();
}
